"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setSessionStorageWithExpiration = exports.getSessionStorageWithExpiration = void 0;
// To use either localStorage or sessionStorage functions
const setSessionStorageWithExpiration = (key, value, expirationTimeInMilliseconds) => {
  const item = {
    value: value,
    expiration: Date.now() + expirationTimeInMilliseconds
  };
  sessionStorage.setItem(key, JSON.stringify(item));
};
exports.setSessionStorageWithExpiration = setSessionStorageWithExpiration;
const getSessionStorageWithExpiration = key => {
  const item = sessionStorage.getItem(key);
  if (item) {
    const parsedItem = JSON.parse(item);
    if (parsedItem.expiration >= Date.now()) {
      return parsedItem.value;
    }
    sessionStorage.removeItem(key);
    return null;
  }
  return null;
};
exports.getSessionStorageWithExpiration = getSessionStorageWithExpiration;